export const X_TC_USERID = Symbol.for('x-tc-userid');
export const AXIOS_CONFIGURATION = Symbol.for('axios-configuration');
export * from './ObjectSerializer';
//# sourceMappingURL=index.js.map